import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import TextInput from 'components/form/TextInput'
import LandingUrl from 'features/creative/add/common/LandingUrl'
import { useDispatch, useSelector } from 'react-redux'
import {
  reset,
  resetImage,
  setAlt,
  setImage,
  setIndividual,
  setMobileUrl,
  setPcUrl,
} from 'features/creative/add/asset/multiThumbnailSlice'
import ErrorText from 'components/form/ErrorText'
import useChannelLandingUrlPolicy from 'features/creative/add/common/useChannalLandingUrlPolicy'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'
import Button from 'components/form/Button'
import { ImageSizes } from 'features/image/ImageSizes'
import ImageLibraryUpload from 'features/creative/add/common/ImageLibraryUpload'

const MultiThumbnail = ({ disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const { images } = useSelector(state => state.creative.assets.multiThumbnail)
  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            이미지형 &gt; 멀티썸네일
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('multiThumbnail'))
              }}>
              삭제
            </Button>
          </strong>
          <MultiThumbnailItem
            index={0}
            disabled={disabled}
            errors={errors?.images[0]}
            imported={imported}
          />
          <MultiThumbnailItem
            index={1}
            disabled={disabled}
            errors={errors?.images[1]}
            imported={imported}
          />
          <MultiThumbnailItem
            index={2}
            disabled={disabled}
            errors={errors?.images[2]}
            imported={imported}
          />
        </div>
        <Preview type="MULTI_THUMBNAIL" data={{ images }} />
      </div>
    </div>
  )
}

const MultiThumbnailItem = ({ index, disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const { images } = useSelector(state => state.creative.assets.multiThumbnail)

  useChannelLandingUrlPolicy(
    v =>
      setIndividual({
        index,
        checked: v,
      }),
    disabled,
    imported
  )

  const { url, name, size, landingUrl, alt } = images[index]

  const onChangeDescription = v => {
    dispatch(
      setAlt({
        index,
        alt: v,
      })
    )
  }
  const onChangeIndividual = checked => {
    dispatch(
      setIndividual({
        index,
        checked,
      })
    )
  }
  const onChangeMobileUrl = v => {
    dispatch(
      setMobileUrl({
        index,
        url: v,
      })
    )
  }
  const onChangePcUrl = v => {
    dispatch(
      setPcUrl({
        index,
        url: v,
      })
    )
  }
  const handleImageUpload = selectedImages => {
    const [image] = selectedImages
    dispatch(
      setImage({
        index,
        image,
      })
    )
  }
  const onClickDelete = () => dispatch(resetImage({ index }))

  return (
    <div className="inner_material">
      <div className="material_item">
        <div className="tit_itemwrap">
          <strong className="tit_item">
            이미지{index + 1}
            <span className="fc_warn">*</span>
          </strong>
        </div>
        <div className="desc_item">
          <ImageLibraryUpload
            handleImageUpload={handleImageUpload}
            onClickDelete={onClickDelete}
            maxCount={1}
            requiredImageSize={[ImageSizes['450x450']]}
            imageUrl={url}
            imageName={name}
            imageSize={size}
            disabled={disabled}
          />
          <ErrorText error={errors?.url} />
        </div>
      </div>
      <div className="material_item">
        <div className="tit_itemwrap">
          <strong className="tit_item">내용{index + 1}</strong>
        </div>
        <div className="desc_item">
          <TextInput
            value={alt}
            trim
            onValueChange={onChangeDescription}
            placeholder="내용을 입력하세요"
            maxLength={6}
            disabled={disabled}
            error={errors?.alt}
          />
          <ErrorText error={errors?.alt} />
        </div>
      </div>
      <LandingUrl
        title={`랜딩 URL${index + 1}`}
        individual={landingUrl.individual}
        mobileUrl={landingUrl.mobileUrl}
        pcUrl={landingUrl.pcUrl}
        onChangeIndividual={onChangeIndividual}
        onChangeMobileUrl={onChangeMobileUrl}
        onChangePcUrl={onChangePcUrl}
        disabled={disabled}
        errors={{
          mobileUrl: errors?.landingUrl.mobileUrl,
          pcUrl: errors?.landingUrl.pcUrl,
        }}
      />
    </div>
  )
}

export default MultiThumbnail

MultiThumbnailItem.propTypes = {
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({
    url: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    alt: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    landingUrl: PropTypes.shape({
      mobileUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
        .isRequired,
      pcUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    }),
  }),
  imported: PropTypes.bool,
}

MultiThumbnail.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  imported: PropTypes.bool,
}
